
import { Component, Watch } from "vue-property-decorator";

import NewsTicker from "../../components/features/NewsTicker.vue";
import DeviceType from "../../utils/DeviceUtil";
import videoDirective from "./positioning-directives/video-directive";
import battleRoom from "./positioning-directives/battle-room-directive";
import workshops from "./positioning-directives/workshops-directive";
import booths from "./positioning-directives/booths-directive";
import infoDesk from "./positioning-directives/info-desk-directive";
import titleFlag from "./positioning-directives/title-flag-directive";
import mobileWidget from "./positioning-directives/mobile-widget-directive";
import {
  getSawVideoTutorial,
  setSawVideoTutorial
} from "../../utils/VideoTutorialUtil";
import { mixins } from "vue-class-component";
import { Getter } from "vuex-class";
import { LocalizableField } from "../../models/LocalizableField";
import UserManual from "./UserManual.vue";
import PosterModal from "./PosterModal.vue";
import { Route } from "vue-router";
import postersData, { PosterItem } from "@/data/postersData";
import posterDirective, { posterConfigs, PosterConfig } from "./positioning-directives/poster-directive";

@Component({
  directives: {
    videoDirective,
    battleRoom,
    workshops,
    booths,
    infoDesk,
    titleFlag,
    mobileWidget,
    poster: posterDirective
  },
  components: {
    NewsTicker,
    UserManual,
    PosterModal
  }
})
export default class HomePage extends mixins(DeviceType) {
  private showUserManual = false;
  private player: any;
  private isMute = true;
  
  // Poster data
  private posters: PosterItem[] = postersData;
  private posterConfigs: PosterConfig[] = posterConfigs;
  private selectedPosterId: number | null = null;
  private selectedPoster: PosterItem | null = null;

  mounted() {
    this.player = this.$refs.sound as any;
  }
  @Getter("eventTitle") private eventTitle!: string;
  @Getter("userManualEnabled") private userManualEnabled!: boolean;
  created() {
    this.$store.dispatch("fetchSystemSettings");
    this.showUserManual = !getSawVideoTutorial();
  }

  openPosterModal(poster: PosterItem): void {
    this.selectedPosterId = poster.id;
    this.selectedPoster = poster;
    (this.$refs.posterModalComponent as any).open();
  }

  closePosterModal(): void {
    this.selectedPosterId = null;
    this.selectedPoster = null;
  }

  public get screenValues(): {
    height: number;
    width: number;
  } {
    if (this.isMobile || this.isTablet) {
      return {
        width: this.windowWidth * 0.4,
        height: this.windowWidth * 0.4
      };
    }
    return {
      height: this.windowWidth * 0.45,
      width: window.innerWidth
    };
  }

  beforeRouteEnter(to: Route, from: Route, next: CallableFunction) {
    if (window.innerWidth < 768 && !getSawVideoTutorial()) {
      next("/user_manual");
    } else {
      next();
    }
  }

  startVideoTutorial() {
    this.showUserManual = true;
    this.player.pause();
    this.isMute = !this.isMute;
    (this.$refs.userManualComponent as any).play();
  }
  controlBackgroundVideoSound() {
    if (this.isMute) {
      this.player.play();
    } else {
      this.player.pause();
    }

    this.isMute = !this.isMute;
  }
}
